var _path, _path2, _path3, _path4, _path5, _path6, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconAssetsEmpty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 81,
    viewBox: "0 0 64 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5193 0.5L32.6635 8.01227",
    stroke: "#4B81AC",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7765 5.53949L24.2391 9.85414",
    stroke: "#4B81AC",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4149 5.03632L41.1135 9.53003",
    stroke: "#4B81AC",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.223267 38.6496H63.7768V80.5H0.223267V38.6496Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7768 38.6495H0.223267L8.98723 16.6243H55.0129L63.7768 38.6495Z",
    fill: "#BFDAE7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6738 54.0664H24.3347C22.5191 54.0664 21.0514 52.5913 21.0514 50.7665C21.0514 48.9417 22.5191 47.4666 24.3347 47.4666H39.6738C41.4893 47.4666 42.9571 48.9417 42.9571 50.7665C42.9571 52.5913 41.4893 54.0664 39.6738 54.0664Z",
    fill: "#4B81AC"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.23328,
    y: 16.7437,
    width: 45.8135,
    height: 22.1701,
    fill: "#CBE1EC"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAssetsEmpty);
export default __webpack_public_path__ + "static/media/icon_assets_empty.59be2b436a0ce5a6e1aa0dc30b482455.svg";
export { ForwardRef as ReactComponent };